import { render, staticRenderFns } from "./ContentPCR.vue?vue&type=template&id=4736c04c&scoped=true"
import script from "./ContentPCR.vue?vue&type=script&lang=js"
export * from "./ContentPCR.vue?vue&type=script&lang=js"
import style0 from "./ContentPCR.vue?vue&type=style&index=0&id=4736c04c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4736c04c",
  null
  
)

export default component.exports